<template>
  <heartComponent :nowState="2"></heartComponent>
</template>
<script>

import heartComponent from '@/components/fetalMonitor/heart.vue'
export default {
  name: `fetalMonitorheart`,
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {
  },
  components: {
    heartComponent
  }
}
</script>

<style lang="scss" scoped>
</style>